/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 経済条件項目
 * @export
 * @interface ConditionItem
 */
export interface ConditionItem {
    /**
     * PGID
     * @type {number}
     * @memberof ConditionItem
     */
    groupId: number;
    /**
     * ペイメントグループ名
     * @type {string}
     * @memberof ConditionItem
     */
    groupName?: string;
    /**
     * 無線グループ名
     * @type {string}
     * @memberof ConditionItem
     */
    companyGroupName?: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof ConditionItem
     */
    companyId: string;
    /**
     * 会社名
     * @type {string}
     * @memberof ConditionItem
     */
    companyName?: string;
    /**
     * 経済条件ID
     * @type {number}
     * @memberof ConditionItem
     */
    conditionId?: number;
    /**
     * 費目名
     * @type {string}
     * @memberof ConditionItem
     */
    expenseItemName?: string;
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof ConditionItem
     */
    serviceCategory?: ConditionItemServiceCategoryEnum | null;
}


/**
 * @export
 */
export const ConditionItemServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type ConditionItemServiceCategoryEnum = typeof ConditionItemServiceCategoryEnum[keyof typeof ConditionItemServiceCategoryEnum];


/**
 * Check if a given object implements the ConditionItem interface.
 */
export function instanceOfConditionItem(value: object): value is ConditionItem {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function ConditionItemFromJSON(json: any): ConditionItem {
    return ConditionItemFromJSONTyped(json, false);
}

export function ConditionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
        'groupName': json['group_name'] == null ? undefined : json['group_name'],
        'companyGroupName': json['company_group_name'] == null ? undefined : json['company_group_name'],
        'companyId': json['company_id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'conditionId': json['condition_id'] == null ? undefined : json['condition_id'],
        'expenseItemName': json['expense_item_name'] == null ? undefined : json['expense_item_name'],
        'serviceCategory': json['service_category'] == null ? undefined : json['service_category'],
    };
}

export function ConditionItemToJSON(json: any): ConditionItem {
    return ConditionItemToJSONTyped(json, false);
}

export function ConditionItemToJSONTyped(value?: ConditionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
        'group_name': value['groupName'],
        'company_group_name': value['companyGroupName'],
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'condition_id': value['conditionId'],
        'expense_item_name': value['expenseItemName'],
        'service_category': value['serviceCategory'],
    };
}

